function n(n,t,o){return"function"==typeof n?n(t,o):n}export{n as resolveComponentProps};
//# sourceMappingURL=resolveComponentProps.js.map
